import { DeltaPill } from '@/components/DeltaPill';
import { Flex } from '@/components/Flex';
import { calculateDelta, formatNumber } from '@/utils';
import * as styles from './index.css';

export type ScoreCellProps = {
    value: number | null;
    previousValue: number | null;
    /** Appended to the formatted value (e.g. `点`). Not applied to `N/A` or the delta. */
    unit?: string;
};

export function ScoreCell({ value, previousValue, unit = '' }: ScoreCellProps) {
    return (
        <Flex gap="2.5" className={styles.scoreValue}>
            <span className={styles.scoreNumber}>{value !== null ? `${formatNumber(value)}${unit}` : 'N/A'}</span>
            {value !== null && previousValue !== null ? (
                <DeltaPill delta={calculateDelta(value, previousValue)} />
            ) : null}
        </Flex>
    );
}

export type DistributionCellProps = {
    distribution: {
        favorable: number;
        neutral: number;
        unfavorable: number;
    };
};

export function DistributionCell({ distribution }: DistributionCellProps) {
    const { favorable, neutral, unfavorable } = distribution;

    return (
        <Flex className={styles.distributionBar}>
            <Flex
                align="center"
                justify="center"
                className={styles.distributionBarSegmentVariants.favorable}
                style={{ width: `${favorable}%` }}
            >
                {Math.round(favorable)}%
            </Flex>
            <Flex
                align="center"
                justify="center"
                className={styles.distributionBarSegmentVariants.neutral}
                style={{ width: `${neutral}%` }}
            >
                {Math.round(neutral)}%
            </Flex>
            <Flex
                align="center"
                justify="center"
                className={styles.distributionBarSegmentVariants.unfavorable}
                style={{ width: `${unfavorable}%` }}
            >
                {Math.round(unfavorable)}%
            </Flex>
        </Flex>
    );
}

export const ComparisonTable = { ScoreCell, DistributionCell };
